import type { SelectProps } from '@chakra-ui/react'
import { forwardRef, Select } from '@chakra-ui/react'

import { useInsurers } from '../hooks'

type CompaniesSelectProps = SelectProps

export const CompaniesSelect = forwardRef((props: CompaniesSelectProps, ref) => {
  const { data: dataInsurers } = useInsurers(null, true)

  return (
    <Select {...props} ref={ref}>
      <option value="">
        Všechny pojišťovny
      </option>
      {dataInsurers &&
        dataInsurers.length > 0 &&
        dataInsurers.map((company) => {
          return (
            <option key={company.id} value={company.id}>
              {company.name}
            </option>
          )
        })}
    </Select>
  )
})
